module.exports = __webpack_public_path__ + "static/media/abstract.184ccf34.jpg";